(function (window, $, Argument, app) {
    function Alert() {
        var _this = this;
        
        var getState = function ($alert) {
            return $alert.is('.alert-visible') ? 'visible' : 'hidden';
        };
        
        this.show = function (alert) {
            var $alert = alert instanceof $ ? alert : $(alert);
            
            $alert.slideDown(app.ANIMATION_DURATION);
            
            var repaint = $alert.get(0).offsetHeight;
            
            $alert.addClass('alert-visible');
        };
        
        this.hide = function (alert) {
            var $alert = alert instanceof $ ? alert : $(alert);
            
            $alert.height($alert.height()).slideUp(app.ANIMATION_DURATION).removeClass('alert-visible');
        };
        
        this.toggle = function (alert, show) {
            show = Argument.get(show, null);
            
            if (show === true) {
                this.show(alert);
            } else if (show === false) {
                this.hide(alert);
            } else {
                var state = getState(alert instanceof $ ? alert : $(alert));
                
                if (state === 'visible') {
                    this.hide(alert);
                } else {
                    this.show(alert);
                }
            }
        };
    }
    
    app.registerModule('Alert', new Alert());
})(window, jQuery, Argument, app);
